/**
 * Promisified Delay
 * @param timeInMs
 */
export function promisifiedDelay(timeInMs: number) {
  return new Promise(resolve => {
    setTimeout(resolve, timeInMs);
  });
}
